import { render } from "./debts.vue?vue&type=template&id=0ba3f0e0&scoped=true"
import script from "./debts.vue?vue&type=script&lang=js"
export * from "./debts.vue?vue&type=script&lang=js"

import "./debts.vue?vue&type=style&index=0&id=0ba3f0e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba3f0e0"]])

export default __exports__